
<template>
  <div class="tcu-results-filter__list" :class="{ '_is-open': filterOpen }" :aria-hidden="!filterOpen">
    <button aria-label="Close Filter Dropdown" class="close-filter-menu" :tabindex="filterOpen ? '0' : '-1'" @click="closeFilters">X</button>

    <div class="tcu-results-filter__column" v-if="
      school.length > 0 ||
      departments.length > 0 ||
      teachingAudience.length > 0 ||
      officeType.length > 0
    ">
      <!-- School -->
      <filter-set
        v-if="school.length > 0 && filterTypes['school'].status"
        :list="school"
        :name="filterTypes['school'].name"
        :id="'school'"
      ></filter-set>
      <!-- Department -->
      <filter-set
        v-if="departments.length > 0 && filterTypes['departments'].status"
        :list="departments"
        :name="filterTypes['departments'].name"
        :id="'departments'"
      ></filter-set>
      <!-- Teaching Audience -->
      <filter-set
        v-if="teachingAudience.length > 0 && filterTypes['teaching-audiences'].status"
        :list="teachingAudience"
        :name="filterTypes['teaching-audiences'].name"
        :id="'teaching-audiences'"
      ></filter-set>
      <!-- Teaching Statuss -->
      <filter-set
        v-if="teachingStatus.length > 0 && filterTypes['teaching-status'].status"
        :list="teachingStatus"
        :name="filterTypes['teaching-status'].name"
        :id="'teaching-status'"
      ></filter-set>
      <!-- Office Type -->
      <filter-set
        v-if="officeType.length > 0 && filterTypes['office-types'].status"
        :list="officeType"
        :name="filterTypes['office-types'].name"
        :id="'office-types'"
      ></filter-set>
    </div>

    <div class="tcu-results-filter__column" v-if="filterTypes['areas-study'].status && areasOfStudy.length > 0">
      <!-- Areas of Study -->
      <filter-set
        v-if="areasOfStudy.length > 0 && filterTypes['areas-study'].status"
        :list="areasOfStudy"
        :name="filterTypes['areas-study'].name"
        :id="'areas-study'"
      ></filter-set>
    </div>

    <div class="tcu-results-filter__column" v-if="filterTypes['areasOfInterest'].status && areasOfInterest.length > 0">
      <!-- Areas of Interest -->
      <filter-set
        v-if="areasOfInterest.length > 0 && filterTypes['areasOfInterest'].status"
        :list="areasOfInterest"
        :name="filterTypes['areasOfInterest'].name"
        :id="'areasOfInterest'"
      ></filter-set>
    </div>

    <div class="tcu-results-filter__column" v-if="
      !school.length &
      !departments.length &
      !teachingAudience.length &
      !officeType.length &
      !areasOfStudy.length &
      !areasOfInterest.length
    ">
      No profiles match your current filter selections.
    </div>

  </div>
</template>
<script>
import store from '../store';
import { debounce, formatId, removeDuplicateObjects, sortAlpha } from "../helpers";
import FilterSet from "./FilterSet";

export default {
  components: {
    "filter-set": FilterSet,
  },
  data() {
    return store;
  },
  props: {
    // this component expects a prop of type object
    list: Object
  },
  computed: {
    school: function(){
        return this.getFiltersByRoleProperty('school');
    },
    departments: function(){
        return this.getFiltersByRoleProperty('departments');
    },
    areasOfStudy: function(){
        return this.getFiltersByRoleProperty('areas-study');
    },
    officeType: function(){
        return this.getFiltersByRoleProperty('office-types');
    },
    teachingAudience: function(){
        return this.getFiltersByRoleProperty('teaching-audiences', false);
    },
    teachingStatus: function(){
        return this.getFiltersByRoleProperty('teaching-status');
    },
    areasOfInterest: function(){
        return this.getFiltersByRootProperty('areasOfInterest');
    }
  },
  methods: {
    closeFilters: function(){
      this.$emit('closeFilters');
    },
    /**
     * Creates an array of filters based on properties on the root profile object
     * @param {string} property
     * @param {boolean} sort - if we should sort alphabetically
     * @returns {array}
     */
    getFiltersByRootProperty: function(property, sort = true){
      if (this.filterTypes[property].status == false) {
        return [];
      }
      let list = [];
      // Get list from profiles array
      this.liveProfileData.fsprofiles.forEach((profile) => {
        if (profile[property] && profile[property].length) {
          profile[property].forEach((item) => {
            if (list.indexOf(item) == -1) {
              list.push({
                id: formatId(item),
                displayName: item
              });
            }
          });
        }
      });

      // Remove duplicates and sort by displayName
      list = removeDuplicateObjects(list, 'id');
      list.map((item) => {
        item.status = false;
      });
      if (sort) {
        list = sortAlpha(list, 'displayName');
      }
      return list;
    },
    /**
     * Creates an array of filters based on properties on the profile.role object
     * @param {string} property
     * @param {boolean} sort - if we should sort alphabetically
     * @returns {array}
     */
    getFiltersByRoleProperty: function(property, sort = true){
      if (this.filterTypes[property].status == false) {
        return [];
      }
      let list = [];
      // Get list from profiles array
      this.liveProfileData.fsprofiles.forEach((profile) => {
        profile.roles.forEach((role) => {
          // If the property is a string, just push it to the list
          if (role[property] && typeof role[property] === 'string') {
            if (list.indexOf(role[property]) == -1) {
              list.push({
                id: formatId(role[property]),
                displayName: role[property]
              });
            }
          // If the property is an array, loop over each item
          } else if (role[property] && role[property].length) {
            role[property].forEach((item) => {
              if (list.indexOf(item) == -1) {
                list.push(item);
              }
            });
          // If the property is an object, loop over each item
          } else if (role[property] && typeof role[property] === 'object') {
            if (list.indexOf(role[property]) == -1) {
              list.push(role[property]);
            }
          }
        });
      });

      // Remove any items that don't have a displayName
      list = list.filter(item => item.displayName !== '');

      // Remove duplicates and sort by displayName
      list = removeDuplicateObjects(list, 'id');
      list.map((item) => {
        item.status = false;
      });
      if (sort) {
        list = sortAlpha(list, 'displayName');
      }
      return list;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FilterList.vue